import React from "react";
import "./WhoWeAre.scss";
import {  Divider } from "antd";
import rugbyImg from "../../../assets/images/Musician.png";

export default function WhoWeAreComponent() {
    const stats = [
        {
            count: "32",
            title: "Campaigns",
        },
        {
            count: "2350",
            title: "Participants",
        },
        {
            count: "$350000",
            title: "Funds Raised",
        },
    ];

    // COMPONENT THAT RENDERS EACH STAT IN THE STATISTICS BOX OVER THE IMAGE
    function singleStat(count, title) {
        return (
            <div className="stat">
                <div className="number">{count}</div>
                <div className="stat-name">{title}</div>
            </div>
        );
    }

    return (
        <>
            <div className="whoWe">
                <div className="heading-component">
                    <div className="title">WHO WE ARE?</div>
                    <div className="subTitle">Empowering sports team and organization fundraisers through team fundraising</div>
                </div>
                <div className="content">
                    {/* THE IMAGE AND STATS COMPONENT START HERE */}
                    <div className="left-container">
                        <div className="info-group-entity">
                            <div className="image-container">
                                <img className='rugbyImg' src={rugbyImg} alt="who-we-are-ref-image" />
                            </div>
                            <div className="stats-container">
                                {stats.map((item, i) => {
                                    return (
                                        <>
                                            {singleStat(item.count, item.title)}
                                            {(i !== stats.length - 1) ? (
                                                <Divider className='stats-divider' type='horizontal' dashed />
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    {/* IMAGE AND STATS COMPONENT ENDS HERE */}

                    {/* CONTENT COMPONENT STARTS HERE */}
                    <div className="right-container">
                        <div className="content">
                            Welcome to LFT — your dedicated partner in innovative fundraising for sports teams, clubs, and community groups.<br /><br />
                            At LFT, we empower organizations nationwide with an easy-to-use, highly effective
                            online fundraising platform. Whether you’re launching a campaign or supporting one,
                            our platform is designed for convenience and success.<br /><br />
                            We simplify the fundraising process, making it accessible and hassle-free for everyone. 
                            Teams, clubs, and organizations can set up campaigns in minutes, while supporters can 
                            contribute with just a few clicks. By streamlining the experience, we ensure fundraising 
                            is not only effective but also enjoyable and rewarding for all involved.    
                        </div>
                    </div>
                </div>
                {/* CONTENT COMPONENT ENDS HERE  */}
            </div>

            {/* THE TEAM HUDDLE IMAGE COMPONENT STARTS HERE */}
            <div className="fillerImg-section">
                <div className="section-one">
                    <p>Let's Fundraise</p>
                    <p>Together...</p>
                </div>
                <div className="section-one-subtitle">
                    <p>To build stronger communities</p>
                </div>
                <div className="section-two">
                    <div className="left-container">
                        <span className="span-content"></span>
                    </div>
                    <div className="right-container">
                        <span className="span-content"></span>
                    </div>
                </div>
            </div>
            {/* THE TEAM HUDDLE IMAGE COMPONENT ENDS HERE*/}
        </>
    )
}
